import React from "react";
import KeyIndicatorsTables from "./KeyIndicatorsTables";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
// import { blue } from "@mui/material/colors";

function createData(fundamental, value, failPas) {
	return { fundamental, value, failPas };
}

const fundamentals = [
	createData(
		"5YR P/E Ratio < 22.5",
		40.22,
		<CancelIcon color="error"></CancelIcon>
	),
	createData(
		"5YR ROIC > 9%",
		"44.98%",
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"Shares Outstanding",
		"-11.89%",
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"Cash Flow Growth 5 Yr",
		"32.63B",
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"Net Income Growth 5 Yr",
		"43.53B",
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"Revenue Growth 5 Yr",
		"111.75B",
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"LTL / 5 Yr FCF < 5",
		1.39,
		<VerifiedIcon color="success"></VerifiedIcon>
	),
	createData(
		"5 YR Price to Free Cash Flow < 22.5",
		37.04,
		<CancelIcon color="error"></CancelIcon>
	),
];

function OurFundamentals() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isTablet = useMediaQuery(theme.breakpoints.down("md"));

	return (
		<Box
			sx={{
				marginLeft: isMobile ? "0.5rem" : "3rem",
				marginRight: isMobile ? "0.5rem" : "3rem",
				marginTop: isMobile ? "1.5rem" : "2.5rem",
				justifyContent: "center",
				display: "flex",
			}}
		>
			<TableContainer
				component={Paper}
				elevation={2}
				sx={{
					maxWidth: isMobile ? "88vw" : "75vw",
				}}
			>
				<Table aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell
								align="center"
								colSpan={3}
								sx={{
									fontWeight: "bold",
									fontSize: isMobile ? "1rem" : "1.1rem",
									// backgroundColor: blue[700],
									bgcolor: "primary.main",
									color: "white",
								}}
							>
								Alpha Strategy Fundamentals
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{fundamentals.map((row, index) => (
							<TableRow
								key={row.fundamental}
								sx={{
									borderTop:
										index === 0
											? "none"
											: "2px solid black",
									"&:last-child td, &:last-child th": {
										border: 0,
									},
								}}
							>
								<TableCell
									component="th"
									scope="row"
									sx={{
										fontWeight: "bold",
										fontSize: isTablet ? "0.9rem" : "1rem",
									}}
								>
									{row.fundamental}
								</TableCell>
								<TableCell
									align="right"
									sx={{
										fontWeight: "bold",
										fontSize: isTablet ? "0.9rem" : "1rem",
									}}
								>
									{row.value}
								</TableCell>
								<TableCell
									align="right"
									sx={{
										fontWeight: "bold",
										fontSize: isTablet ? "0.9rem" : "1rem",
									}}
								>
									{row.failPas}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
}

export default function Fundamentals() {
	return (
		<>
			<OurFundamentals></OurFundamentals>
			<KeyIndicatorsTables></KeyIndicatorsTables>
		</>
	);
}
